import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController,  LoadingController } from 'ionic-angular';
import { BasicPage } from "../basic/basic";
import { HttpClient } from '@angular/common/http';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { CardProvider } from '../../providers/data/data';
/**
 * Generated class for the UrlparsePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-urlparse',
  templateUrl: 'urlparse.html',
})
export class UrlparsePage {

  id;
  time;
  hash;
  color = 'red';
  errorCheck = false;
  datas = {
    memberid: '',
    time: '',
    hash: ''
  }
  apiresult;
  stopsettimeout;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public rest: RestProvider,
    public data: DataProvider,
    public card: CardProvider,
    ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UrlparsePage');
    document.getElementById('mainHeader').style.display = 'none';
    // document.getElementById('headTitle').style.display = 'block';    
    // document.getElementById('headTitle').style.marginTop = '-10px';
    this.data.currentTabName = 'トップメニュー';
    this.data.id = null;
    this.data.time = null;
    this.data.hash = null;
    this.presentLoadingDefault();
    this.stopsettimeout = setTimeout(this.move, 0);

    // ここでURLをパースしてリクエストを飛ばす
    try {
        var splitURL = document.URL.split("?");
        var splitParams = splitURL[1].split("&");
        this.id = splitParams[0].split("id=")[1];
        this.time = splitParams[1].split("time=")[1];
        this.hash = splitParams[2].split("hash=")[1];
        if(splitParams.length > 3) {
          this.color = splitParams[3].split("color=")[1];
        }
      } catch (error) {
          console.log(error instanceof TypeError); // => true
          console.log(error.name); // => "TypeError"
          console.log(error.message); // エラーメッセージが表示される
      }

    // idとtimeとhashの値がnullである場合にエラーメッセージを表示する
    if(this.id == null || this.time == null || this.hash == null) {
      this.showAlertError('URLのパラメータが無効です。');
      this.changeErrorPage();
    } else {
      // idとtimeとhashの値がフォーマットに則っているか確かめる
      const hankakunum = /^[0-9]*$/;
      const hankakuengnum = /^[a-zA-Z0-9]+$/;
      if(!hankakunum.test(this.id)) {
        this.showAlertError('idが半角数字ではありません。');
        this.changeErrorPage();
      }
      if(!hankakunum.test(this.time)) {
        this.showAlertError('timeが半角数字ではありません。');
        this.changeErrorPage();
      }
      if(!hankakuengnum.test(this.hash)) {
        this.showAlertError('hashが半角英数字ではありません。');
        this.changeErrorPage();
      }
    }

    // hashが正しければログイン画面へ飛ぶ
    this.sendPostRequest();
  }

  move() {
    var elem = document.getElementById("myBar");
    var width = 1;
    var id = setInterval(frame, 15);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
        elem.style.width = '0%';
        width = 0;
        id = setInterval(frame, 15);
      } else {
        width++;
        elem.style.width = width + '%';
      }
    }
  }

  showAlertSuccess(success) {
    let alert = this.alertCtrl.create({
      title: "成功!",
      subTitle: success,
      buttons: ["OK"]
    });
    alert.present();
  }

  showAlertError(err) {
    let alert = this.alertCtrl.create({
      title: "エラー!",
      subTitle: err,
      buttons: ["OK"],
      cssClass : "alert"
    });
    alert.present();
  }

  presentLoadingDefault() {
    const loading = this.loadingCtrl.create({
      content: 'お待ちください...'
    });

    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 500);
  }

  sendPostRequest() {
    this.rest.checkHash(this.id, this.time, this.hash).subscribe(res => {
      if(res.apiresult == 'COM00_SUCCESS') {
        this.data.id = this.id;
        this.data.time = this.time;
        this.data.hash = this.hash;
        this.color = this.color.substring(0,1);
        if(this.color == 'r') {
          this.card.color = 'red';
        } else if(this.color == 'b') {
          this.card.color = 'blue';
        } else {
          this.card.color = 'green';
        }   
        
        this.card.color = 'red';
        
        if(this.card.color == 'red') {
          this.card.logoPic = 'assets/imgs/logo_procedure_new_' + this.card.color + '.png';
        } else if(this.card.color == 'blue') {
          this.card.logoPic = 'assets/imgs/logo_procedure_new_' + this.card.color + '.png';
        } else if(this.card.color == 'green') {
          this.card.logoPic = 'assets/imgs/logo_procedure_new_' + this.card.color + '.png';
        } else if(this.card.color == 'black') {
          this.card.logoPic = 'assets/imgs/logo_joyplus.png';
        }
        this.card.logoPic = 'assets/imgs/logo_procedure_new_red.png';
        if(res.shopColor != null) {
          if(res.shopColor != "") {
            this.data.sign = res.shopColor;
          } else {
            this.data.sign = "red";
          }
        } else {
          this.data.sign = "red";
        }
        this.navCtrl.push(BasicPage, {color: res.shopColor});
        // this.showAlertSuccess('検証に成功しました。');
      } else {
        this.changeErrorPage();
      }
    }, error => {
      console.log(error);
      this.changeErrorPage();
    });
  }

  changeErrorPage() {
    clearInterval(this.stopsettimeout);
    this.errorCheck = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/urlparse/urlparse.ts